module.exports = __webpack_public_path__ + "fonts/font01-BoldItalic.b39e1c03.woff2";